import axios from "axios";
import { handleApiException, handleResponse } from "helpers/apiResponseHelper";
import { apiService } from "./api.service";

async function getTermsAndConditionsFile(termsAndConditionsId: number, isCompany: boolean) {
  return axios.get(`${apiService.getApiUrl()}/terms-and-conditions/${termsAndConditionsId}/file`, {
      params: {
          isCompany
      },
      responseType: 'blob'
  })
  .then(handleResponse)
  .catch(handleApiException);
}

const TermsAndConditionsService = {
  getTermsAndConditionsFile
};

export default TermsAndConditionsService;